export default "__VITE_ASSET__BeUsU_K8__"